import { render } from "./Clock.vue?vue&type=template&id=1ebd8ea2&scoped=true"
import script from "./Clock.vue?vue&type=script&lang=js"
export * from "./Clock.vue?vue&type=script&lang=js"

import "./Clock.vue?vue&type=style&index=0&id=1ebd8ea2&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ebd8ea2"]])

export default __exports__